import { render, staticRenderFns } from "./ProductsAddResale.vue?vue&type=template&id=82bca84a&scoped=true"
import script from "./ProductsAddResale.vue?vue&type=script&lang=js"
export * from "./ProductsAddResale.vue?vue&type=script&lang=js"
import style0 from "./ProductsAddResale.vue?vue&type=style&index=0&id=82bca84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bca84a",
  null
  
)

export default component.exports